import { MOVE_REST_MS } from '@developerz/domain';
import { createMemo, type JSX, on, untrack } from 'solid-js';
import { type Rest, restLeft } from '../../lib/move-rest';

// The resting ring (#6772, prototype gripHTML's cool arm `:1787-1790`): 14 px, a track circle
// (r 5.5, stroke 1.8) and the live arc draining linearly from the rest's start to its end. The
// arc's inline `stroke-dashoffset` is its fill at the page clock (the still frame reduced motion
// shows); otherwise a CSS animation of the whole rest, started where the clock stood when the rest
// began showing, drains it smoothly (an animation outranks the inline value). That delay is fixed
// per rest: the timeline advances on its own, so a delay that grew with each clock tick would skip
// the arc ahead and finish it early.

export function MoveRing(props: { readonly rest: Rest; readonly nowMs: number }): JSX.Element {
  const gone = () => 100 * (1 - restLeft(props.rest, props.nowMs));
  /** Read once per rest (keyed by its start), never per tick. */
  const delay = createMemo(
    on(
      () => props.rest.startMs,
      (startMs) => Math.max(0, untrack(() => props.nowMs) - startMs),
    ),
  );
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" class="move-ring">
      <circle class="move-ring__track" cx="8" cy="8" r="5.5" />
      <circle
        class="move-ring__arc--live"
        cx="8"
        cy="8"
        r="5.5"
        pathLength="100"
        stroke-dasharray="100"
        transform="rotate(-90 8 8)"
        style={{
          'stroke-dashoffset': String(gone()),
          'animation-duration': `${MOVE_REST_MS}ms`,
          'animation-delay': `-${delay()}ms`,
        }}
      />
    </svg>
  );
}
